import { render, staticRenderFns } from "./list-tokens.vue?vue&type=template&id=0ba20c75&scoped=true&"
import script from "./list-tokens.vue?vue&type=script&lang=ts&"
export * from "./list-tokens.vue?vue&type=script&lang=ts&"
import style0 from "./list-tokens.vue?vue&type=style&index=0&id=0ba20c75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba20c75",
  null
  
)

export default component.exports